export const NEW = 'NEW';
export const LOADING = 'LOADING';
export const OKAY = 'OKAY';
export const FAILED = 'FAILED';
export const DIVERGED = 'REMOTE_CHANGE_OCCURRED';
export const DISABLED = 'DISABLED';
export const DISCONNECTED = 'DISCONNECTED';
